<!--
 * @Author: Lemon C
 * @Date: 2024-04-22 15:27:06
 * @LastEditTime: 2025-03-11 10:14:20
-->
<template>
    <div class="nav-control-footer-body">
        <div class="re-w1200 re-main-col">
            <div class="footer-top">
                <div class="footer-logo-box">
                    <div class="footer-logo" @click="btn_switch_router({ route: '/home' })">
                        <img src="@/assets/imgs/logo/login_light.png" alt="" />
                    </div>
                </div>
                <div class="footer-content">
                    <div class="route-box" v-for="(item, index) in contentList" :key="index">
                        <span class="route-title">{{ item.title }}</span>
                        <div
                            :class="`${subItem.jump ? 'jump-cursor' : ''} route-name-box`"
                            v-for="(subItem, subIndex) in item.subItem"
                            :key="subIndex"
                            @click="btn_switch_router(subItem)">
                            <img
                                class="route-img"
                                v-if="subItem.icon && subItem.icon.length > 0"
                                :src="require(`@/assets/imgs/general/${subItem.icon}.png`)" />
                            <span :class="`${subItem.jump ? 'route-name' : 'route-name-not-jump'}`">{{ subItem.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="right-qr-code-box">
                        <img src="@/assets/imgs/general/wechat-account.png" />
                        <span>微信公众号</span>
                    </div>
                </div>
            </div>
            <div class="footer-line"></div>
            <span class="footer-copyright"
                >Copyright
                ©2018-至今&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海秉匠信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;版权所有：沪ICP备18040952号-4</span
            >
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref } from 'vue';

const props = defineProps({
    nav_footer_router_callback: Function,
});

const contentList = ref([
    {
        title: '文档中心',
        subItem: [
            { name: '功能教程', route: '/docs/guide', jump: true },
            { name: '服务端 API', route: '/docs/service-api', jump: true },
            { name: 'JavaScript API', route: '/docs/js-api', jump: true },
            { name: 'Android API', route: '/docs/android-api', jump: true },
            { name: 'iOS API', route: '/docs/ios-api', jump: true },
            { name: '示例Demo', route: '/docs/web-demo', jump: true },
        ],
    },
    {
        title: '联系我们',
        subItem: [
            { name: '公司地址：上海市闵行区宜山路1698号兴迪商务大厦1506室', route: '', icon: 'icon_address', jump: false },
            { name: '公司邮箱：development@bjblackhole.com', route: '', icon: 'icon_mail', jump: false },
            { name: '联系电话：021-57835688', route: '', icon: 'icon_phone', jump: false },
            { name: '业务联系：王振清（华中&北方地区）：137 1841 3836', route: '', icon: 'icon_phone', jump: false },
            { name: '业务联系：石朗忠（南方地区）：139 2163 6108', route: '', icon: 'icon_phone', jump: false },
            { name: '业务联系：郭倩（其他地区）：136 2850 8343', route: '', icon: 'icon_phone', jump: false },
        ],
    },
]);

// MARK 路由跳转
const btn_switch_router = (item) => {
    props.nav_footer_router_callback(item);
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.nav-control-footer-body {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 445px;
    flex-shrink: 0;
    background-color: var(--color-main-dark-bg);

    .footer-top {
        position: relative;
        width: 100%;
        flex: 1;
        display: flex;

        .footer-logo-box {
            position: relative;
            width: 210px;
            height: 100%;
            flex-shrink: 0;

            .footer-logo {
                position: relative;
                cursor: pointer;
                width: 100%;
                height: 59px;
                margin-top: 45px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .footer-content {
            position: relative;
            display: flex;
            flex: 1;
            display: flex;

            .route-box {
                position: relative;
                margin-top: 54px;
                display: flex;
                flex-direction: column;
                margin-left: 100px;

                .route-title {
                    position: relative;
                    margin-bottom: 16px;
                    height: 36px;
                    line-height: 28px;
                    color: var(--color-main-text-dark-bg-primary);
                    font-size: 24px;
                    font-weight: 500;
                }

                .route-name-box {
                    position: relative;
                    margin-bottom: 16px;
                    width: 100%;
                    height: 24px;
                    display: flex;
                    align-items: center;

                    .route-img {
                        position: relative;
                        margin-right: 12px;
                        width: 16px;
                        height: 16px;
                    }

                    .route-name,
                    .route-name-not-jump {
                        position: relative;
                        color: var(--color-main-text-footer-default);
                        font-size: 14px;
                        font-weight: 400;
                    }

                    &:hover .route-name {
                        color: var(--color-main-brand-hover);
                    }
                }
                .jump-cursor {
                    cursor: pointer;
                }
            }
        }

        .footer-right {
            position: relative;
            width: 200px;
            height: 100%;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;

            .right-qr-code-box {
                position: relative;
                margin-top: 54px;
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;

                img {
                    width: 150px;
                    height: 150px;
                    transition: var(--animation-transform-style);
                    &:hover {
                        transform: var(--transform-scale-105);
                    }
                }

                span {
                    margin-top: 16px;
                    height: 27px;
                    font-weight: 400;
                    font-size: 18px;
                    color: var(--color-main-text-footer-default);
                    line-height: 21px;
                    text-align: center;
                }
            }
        }
    }

    .footer-line {
        position: relative;
        margin-bottom: 32px;
        height: 1px;
        width: 100%;
        background-color: var(--color-main-text-footer-secondary);
    }

    .footer-copyright {
        position: relative;
        margin-bottom: 32px;
        color: var(--color-main-text-footer-secondary);
        font-size: 12px;
        font-weight: 500;
        width: 100%;
        height: 18px;
        text-align: center;
    }
}
</style>
